import { TranslationsType } from '@/modules/common';



import { golfSimulatorIcon, gpsIcon, orderIcon, promosIcon, studioIcon } from './icons';





const API_URL = 'https://saywhatt-frj5cmaowa-uk.a.run.app'
const API_KEY =
  'cGxheWJldHRlcjpza19saXZlX2puV2tRTXlETGdweFVhRVI3dFBjTGRCZ2xJbHN4WnFNYVNyMVl3b0JleEVkQlJNRktiR01pQ0pmMGppNnVBS1ExZFg5NG43cGlER0lDTlo3bWZ1dElDQ2RUVmpEVEI4Qlo4Rm8yVkpjUElZRnA1M0NTS281aHNGNFYzdWN5WWUyR1NTUU1qc3BiVWFYa3htalVGMEN5dWgzQ0tucWtPbkVJTlpvZzdtbUVN';

export const config = {
  projectName: 'PLAYBETTER',
  apiKey: API_KEY,
  apiUrl: API_URL,
  translations: {
    inputPlaceholder: 'Ask me anything',
  } as TranslationsType,
  prompts: [
    {
      caption: 'Simulators',
      iconSvg: golfSimulatorIcon,
    },
    {
      caption: 'Studio packages',
      iconSvg: studioIcon,
    },
    {
      caption: 'GPS & rangefinders',
      iconSvg: gpsIcon,
    },
    {
      caption: 'My order',
      iconSvg: orderIcon,
    },
    {
      caption: 'Promotions',
      iconSvg: promosIcon,
    },
  ],
  theme: {
    colors: {
      light: '#213249',
      dark: '#213249',
    },
    container: {
      mobile: {
        height: 'calc(100% - 15px)',
      },
    },
    messageText: {
      ml: {
        '.check-it-out': {
          color: '#f7002f',
        },
        '.product-button': {
          color: '#fff',
        },
        '.product-quantity': {
          input: {
            borderColor: '#213249',
          },
          button: {
            borderColor: '#213249',
            color: '#213249',
          },
        },
      },
    },
    embeddedPage: {
      global: {
        '#saywhatt-page': {
          height: 'calc(100dvh - 216px)',
          '@media (max-width: 768px)': {
            height: 'calc(100dvh - 95px)',
          }
        },
        footer: {
          display: 'none',
        },
      },
    },
  },
};
